import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_2 = { style: {"width":"50%"} }
const _hoisted_3 = ["onClick"]

  
const __default__ = {
  name: 'leaseTeamCost'
}
import tbMix from '@/global_mixin/tableMixin'
import { useRoute } from 'vue-router'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const  {
  'POST/house_lease_costs/every_org': fetchList,
} = Api

const route = useRoute()
const { 
  MI_tableData, fetchData, page, size, 
  MI_total, MI_pageChange, MI_sizeChange, 
  MI_identify, MI_params,
} = new tbMix(fetchList)

fetchData({
  ...route.params,
  startDate: '',
  endDate: '',
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      icon: "Back",
      class: "mb-10 mt-10",
      type: "info",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({ path: '/lease-cost-query' })))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_descriptions, { border: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, { label: "团队" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$route.params.orgName), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_divider),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "tb",
        border: "",
        data: _unref(MI_tableData)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "日期",
            prop: "date"
          }),
          _createVNode(_component_el_table_column, {
            label: "在职人数",
            prop: "peopleQuantity",
            align: "right"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", {
                class: "pointer",
                onClick: ($event: any) => (_ctx.$router.push({ name: 'leaseCost', params: {orgId: _ctx.$route.params.orgId, date: row.date + '-01', orgName: _ctx.$route.params.orgName }}))
              }, _toDisplayString(row.peopleQuantity), 9, _hoisted_3)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "房租",
            prop: "rentFee",
            align: "right",
            formatter: _unref(formatNumber)
          }, null, 8, ["formatter"]),
          _createVNode(_component_el_table_column, {
            label: "水电费",
            prop: "utilitiesFee",
            align: "right",
            formatter: _unref(formatNumber)
          }, null, 8, ["formatter"]),
          _createVNode(_component_el_table_column, {
            label: "物管费",
            prop: "pmFee",
            align: "right",
            formatter: _unref(formatNumber)
          }, null, 8, ["formatter"]),
          _createVNode(_component_el_table_column, {
            label: "其他费用",
            prop: "otherFee",
            align: "right",
            formatter: _unref(formatNumber)
          }, null, 8, ["formatter"]),
          _createVNode(_component_el_table_column, {
            label: "未分配费用",
            prop: "unassignedFee",
            align: "right",
            formatter: _unref(formatNumber)
          }, null, 8, ["formatter"]),
          _createVNode(_component_el_table_column, {
            label: "电脑费用",
            prop: "computerFee",
            align: "right",
            formatter: _unref(formatNumber)
          }, null, 8, ["formatter"]),
          _createVNode(_component_el_table_column, {
            label: "总计",
            prop: "total",
            align: "right",
            formatter: _unref(formatNumber)
          }, null, 8, ["formatter"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _unref(MI_identify)]
      ])
    ])
  ]))
}
}

})